import Blog from "@/Layouts/Blog";
import Contact from "@/Sections/Contact";
import { Head } from "@inertiajs/inertia-react";

export default () => {
    return (
        <Blog>
            <Head>
                <title>
                    Ontdek de kracht van thermogenese voor een top shape!
                </title>
                <link rel="canonical" href={route("blogs.forty-eight")} />

                <meta
                    name="viewport"
                    content="width=device-width, initial-scale=1"
                />
                <meta property="og:locale" content="nl_NL" />

                <meta
                    name="description"
                    content="Wist u dat het voedsel dat u eet, een cruciale rol kan spelen in uw streven om gewicht te verliezen? Ja, u hoort het goed! Het gaat allemaal om een fascinerend proces genaamd thermogenese. Maar wat is thermogenese precies en hoe kan het ons helpen om af te vallen? Laten we dit eens nader bekijken."
                />
                <meta
                    property="og:description"
                    content="Wist u dat het voedsel dat u eet, een cruciale rol kan spelen in uw streven om gewicht te verliezen? Ja, u hoort het goed! Het gaat allemaal om een fascinerend proces genaamd thermogenese. Maar wat is thermogenese precies en hoe kan het ons helpen om af te vallen? Laten we dit eens nader bekijken."
                />
                <meta property="og:url" content={route("blogs.forty-eight")} />
                <meta property="og:type" content="article" />
                <meta
                    property="og:title"
                    content="Ontdek de kracht van thermogenese voor een top shape! - WE ARE Personal Training Uden en Schijndel"
                />
                <meta
                    property="og:image"
                    content="/assets/blog/thermogenese.png"
                />
            </Head>

            <div className="bg-black">
                <div className="relative xs:h-[30vh] sm:h-[30vh] md:h-[65vh] lg:h-[65vh] pb-32">
                    <div>
                        <div className="absolute inset-0">
                            <picture>
                                <source
                                    srcSet="/assets/blog/webp/thermogenese.webp"
                                    type="image/webp"
                                    alt="Thermogenese"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                                <source
                                    srcSet="/assets/blog/thermogenese.png"
                                    type="image/jpeg"
                                    alt="Thermogenese"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                                <img
                                    src="/assets/blog/thermogenese.png"
                                    alt="Thermogenese"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                            </picture>
                            <div
                                className="absolute inset-0 bg-gray-800 opacity-50 mix-blend-multiply"
                                aria-hidden="true"
                            />
                        </div>
                    </div>
                </div>
                <div className="xs:px-8 sm:px-8 md:px-16 lg:px-16 xs:py-12 sm:py-12 md:py-24 lg:py-24 max-w-7xl mx-auto">
                    <h1 className="block text-white font-custom italic font-bold uppercase xl:inline xs:text-5xl sm:text-5xl md:text-6xl lg:text-6xl break-words">
                        Ontdek de kracht van thermogenese voor een top shape!
                    </h1>
                    <p className="mt-4 text-gray-100 break-words">
                        Wist u dat het voedsel dat u eet, een cruciale rol kan
                        spelen in uw streven om gewicht te verliezen? Ja, u
                        hoort het goed! Het gaat allemaal om een fascinerend
                        proces genaamd thermogenese. Maar wat is thermogenese
                        precies en hoe kan het ons helpen om af te vallen? Laten
                        we dit eens nader bekijken.
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Wat is thermogenese?
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Thermogenese is een{" "}
                        <a
                            href={route("blogs.twenty-one")}
                            className="text-we-are-yellow"
                        >
                            metabolisch
                        </a>{" "}
                        proces waarbij uw lichaam calorieën verbrandt om warmte
                        te produceren. Er zijn drie soorten thermogenese: door
                        oefening geïnduceerde thermogenese (EIT), niet-oefening
                        activiteit thermogenese (NEAT) en voeding-geïnduceerde
                        thermogenese (DIT).
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Voor dit artikel zullen we ons concentreren op
                        voeding-geïnduceerde thermogenese, die optreedt als
                        reactie op wat we eten. Simpel gezegd, sommige
                        voedingsmiddelen vereisen meer energie om te verteren,
                        absorberen en metaboliseren dan andere, wat leidt tot
                        een verhoogde calorieverbranding.
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Hoe helpt thermogenese bij het afvallen?
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Wanneer u voedsel eet dat een hoge thermogenese
                        veroorzaakt, verbrandt uw lichaam meer calorieën tijdens
                        de spijsvertering. Dit betekent dat u minder calorieën
                        opslaat als vet, wat u kan helpen om{" "}
                        <a
                            href={route("blogs.twenty-six")}
                            className="text-we-are-yellow"
                        >
                            gewicht
                        </a>{" "}
                        te verliezen of uw huidige gewicht te behouden.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Studies hebben aangetoond dat het verhogen van uw
                        thermogenese kan bijdragen aan een verhoogd
                        energieverbruik en vetverlies. Dit betekent dat door het
                        kiezen van de juiste voedingsmiddelen, u uw lichaam in
                        een natuurlijke vetverbrandingsmachine kunt veranderen.
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Voedingsmiddelen met hoge thermogenese
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Er zijn bepaalde voedingsmiddelen die bekend staan om
                        hun hoge thermogene effect. Dit zijn onder andere:
                    </p>
                    <ol className="mt-4 text-gray-100 list-decimal">
                        <li>
                            <b>Eiwitten</b>:{" "}
                            <a
                                href={route("blogs.forty-one")}
                                className="text-we-are-yellow"
                            >
                                Eiwitten
                            </a>{" "}
                            hebben het hoogste thermogene effect van alle
                            macronutriënten. Ze vereisen ongeveer 20-30% van de
                            verbruikte calorieën voor de spijsvertering en
                            absorptie.
                        </li>
                        <li>
                            <b>Capsaïcine</b>: Dit is de stof die pepers hun
                            hitte geeft. Het is aangetoond dat het de
                            thermogenese verhoogt en de vetoxidatie bevordert.
                        </li>
                        <li>
                            <b>Cafeïne</b>: Cafeïne kan het metabolisme verhogen
                            en de vetverbranding stimuleren.
                        </li>
                        <li>
                            <b>Voedingsvezels</b>: Vezelrijk voedsel kan de
                            thermogenese verhogen door de{" "}
                            <a
                                href={route("blogs.twentieth")}
                                className="text-we-are-yellow"
                            >
                                spijsvertering
                            </a>{" "}
                            te vertragen en u langer vol te laten voelen.
                        </li>
                    </ol>
                    <p className="mt-4 text-gray-100 break-words">
                        Door deze voedingsmiddelen in uw dieet op te nemen, kunt
                        u uw lichaam helpen om meer calorieën te verbranden en
                        mogelijk gewicht te verliezen.
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Conclusie
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Thermogenese van voeding is een krachtig hulpmiddel dat
                        u kan helpen bij uw gewichtsverliesdoelen. Door te
                        kiezen voor voedingsmiddelen die een hoge thermogenese
                        veroorzaken, kunt u uw lichaam in een
                        vetverbrandingsmachine veranderen. Echter, zoals bij elk
                        dieet of gewichtsverlies strategie, is het belangrijk om
                        een evenwichtige aanpak te volgen en altijd te streven
                        naar een gezonde levensstijl.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Voeg dus wat pit toe aan uw maaltijden, geniet van een
                        kopje koffie en zorg ervoor dat u voldoende eiwitten en
                        vezels binnenkrijgt. Uw lichaam zal u dankbaar zijn!
                    </p>
                    {/* -- */}
                    <h3 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl">
                        Bibliografie
                    </h3>
                    <p className="mt-4 text-gray-100 break-words">
                        De informatie in dit artikel is gebaseerd op betrouwbare
                        bronnen uit de literatuur.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Westerterp, K. R. (2004). Diet induced thermogenesis.
                        Nutrition & Metabolism, 1(1), 5.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Reinbach, H. C., Smeets, A., Martinussen, T., Møller,
                        P., & Westerterp-Plantenga, M. S. (2009). Effects of
                        capsaicin, green tea and CH-19 sweet pepper on appetite
                        and energy intake in humans in negative and positive
                        energy balance. Clinical Nutrition, 28(3), 260-265.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        3. Acheson, K. J., Zahorska-Markiewicz, B., Pittet, P.,
                        Anantharaman, K., & Jéquier, E. (1980). Caffeine and
                        coffee: their influence on metabolic rate and substrate
                        utilization in normal weight and obese individuals. The
                        American journal of clinical nutrition, 33(5), 989-997.
                    </p>
                </div>
                <Contact />
            </div>
        </Blog>
    );
};
